<template>
  <el-card shadow="never" v-loading="loading">
    <el-table :data="transactions" :row-class-name="tableRowClassName">
      <el-table-column type="expand">
        <template slot-scope="scope">
          <el-card v-if="scope.row.refunded">
            <el-descriptions title="Refund Details">
              <el-descriptions-item label="Status"> {{ scope.row.refund.status }}</el-descriptions-item>
              <el-descriptions-item label="Refund by"> {{ scope.row.refund.createdBy }}</el-descriptions-item>
              <el-descriptions-item label="Refund At"> {{ scope.row.refund.createdAt | formatDate }}</el-descriptions-item>
              <el-descriptions-item :key="index" v-for="(value, key, index) in scope.row.refund.response.transaction" :label="key">
                <div v-if="typeof value === 'string' || typeof value === 'number'">
                  {{ value }}
                </div>
                <!-- <div v-else-if="!Array.isArray(value) && typeof value === 'object'" :key="innerIndex" v-for="(valueOfObject, key, innerIndex) in value">
                  <div v-if="typeof valueOfObject !== 'object'">
                    {{ key }}: {{ valueOfObject  }}
                  </div>
                </div> -->
              </el-descriptions-item>
            </el-descriptions>
          </el-card>
          <el-card :key="event._id" v-for="event of scope.row.events" shadow="never">
            <el-descriptions title="Events">
              <el-descriptions-item label="Status"> {{ event.status }}</el-descriptions-item>
              <el-descriptions-item label="Event by"> {{ event.createdBy }}</el-descriptions-item>
              <el-descriptions-item label="Event At"> {{ event.createdAt | formatDate }}</el-descriptions-item>
              <el-descriptions-item v-if="typeof event.details === 'string' || typeof event.details === 'number'" label="Details"> {{ event.details }}</el-descriptions-item>
              <el-descriptions-item v-else-if="event.details && event.details.transaction" :key="index" v-for="(value, key, index) in event.details.transaction" :label="key">
                <div v-if="typeof value === 'string' || typeof value === 'number'">
                  {{ value }}
                </div>
                <!-- <div v-else-if="!Array.isArray(value) && typeof value === 'object'" :key="innerIndex" v-for="(valueOfObject, key, innerIndex) in value">
                  <div v-if="typeof valueOfObject !== 'object'">
                    {{ key }}: {{ valueOfObject  }}
                  </div>
                </div> -->
              </el-descriptions-item>
            </el-descriptions>
          </el-card>
        </template>
      </el-table-column>

      <el-table-column label="Transaction ID" prop="id" :width="150">
        <template slot-scope="scope">
          <el-tag>
            {{ scope.row.id }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Created At" :width="180" >
        <template slot-scope="scope">
          {{ new Date(scope.row.createdAt).toLocaleString() }}
        </template>
      </el-table-column>
      <el-table-column label="Type" prop="type"></el-table-column>
      <el-table-column label="Last 4 digits" :width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.source">
            {{  scope.row.source }}</el-tag>
            <div v-else>
              <el-tag
                v-if="scope.row.type === 'ACH' && scope.row.events[1] && scope.row.events[1].details && scope.row.events[1].details.transaction && scope.row.events[1].details.transaction.usBankAccount && scope.row.events[1].details.transaction.usBankAccount.last4">
                {{ scope.row.events[1].details.transaction.usBankAccount.last4 }}
              </el-tag>
              <el-tag
                v-if="scope.row.type === 'ACH' && scope.row.events[1] && scope.row.events[1].details && scope.row.events[1].details.result && scope.row.events[1].details.result.transaction && scope.row.events[1].details.result.transaction.usBankAccount && scope.row.events[1].details.result.transaction.usBankAccount.last4">
                {{ scope.row.events[1].details.result.transaction.usBankAccount.last4 }}
              </el-tag>
              <el-tag
                v-if="scope.row.type === 'ACH' && scope.row.events[1] && scope.row.events[1].details && scope.row.events[1].details.result && scope.row.events[1].details.result.transaction && scope.row.events[1].details.result.transaction.creditCard && scope.row.events[1].details.result.transaction.creditCard.last4">
                {{ scope.row.events[1].details.result.transaction.creditCard.last4 }}
              </el-tag>
              <el-tag v-if="scope.row.type === 'CREDIT_CARD' && scope.row.events[1] && scope.row.events[1].details && scope.row.events[1].details.transaction && scope.row.events[1].details.transaction.creditCard && scope.row.events[1].details.transaction.creditCard.last4">
                <div>{{ scope.row.events[1].details.transaction.creditCard.last4 }}</div>
              </el-tag>
              <el-tag v-if="scope.row.type === 'CREDIT_CARD' && scope.row.events[1] && scope.row.events[1].details && scope.row.events[1].details.result && scope.row.events[1].details.result.transaction && scope.row.events[1].details.result.transaction.creditCard && scope.row.events[1].details.result.transaction.creditCard.last4">
                <div>{{ scope.row.events[1].details.result.transaction.creditCard.last4 }}</div>
              </el-tag>
            </div>
            <div v-show="scope.row.type !== 'ACH' && scope.row.type !== 'CREDIT_CARD'">--</div>
          </template>
        </el-table-column>
      <el-table-column label="Initiated By" prop="createdBy" :width="150"></el-table-column>
      <el-table-column label="Status" :width="120">
        <template slot-scope="scope">
          <el-tag v-if="!scope.row.success" :type="scope.row.events[scope.row.events.length - 1].status.toUpperCase() === 'FAILED' ? 'danger' : 'warning' ">
            {{ scope.row.events[scope.row.events.length - 1].status.toUpperCase() }}
          </el-tag>
          <el-tag v-else type="success">
            {{ scope.row.events[scope.row.events.length - 1].status.toUpperCase() }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Wallet Amount" prop="amount" :width="150" align="center">
        <template slot-scope="scope">
          <el-tag effect="plain">
            {{ scope.row.amount | currencySign($root.state.facilityData) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Total Amount" prop="amountPaid" :width="150" align="center">
        <template
          v-if="scope.row.type === 'CREDIT_CARD'" slot-scope="scope">
          <el-tag v-if="scope.row.creditCardFee && scope.row.success && scope.row.enabledCreditCardFee" effect="plain">
            {{ scope.row.amount + scope.row.creditCardFee  | currencySign($root.state.facilityData) }}
          </el-tag>
          <el-tag v-else-if="scope.row.creditCardFee && !scope.row.success" effect="plain">
            {{ 0  | currencySign($root.state.facilityData) }}
          </el-tag>
          <el-tag v-else effect="plain">
            {{ scope.row.amount  | currencySign($root.state.facilityData) }}
          </el-tag>
         </template>
      </el-table-column>
      <el-table-column label="Description" prop="details" :width="450"></el-table-column>
      <el-table-column
        label="Actions"
        fixed="right"
        :width="190"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-view"
            @click="() => openTransactionDetails(scope.row)"
          >View</el-button>
          <el-popconfirm
            v-if="!['ACH', 'CREDIT_CARD', 'WRITE_OFF'].includes(scope.row.type)"
            confirm-button-text='Confirm'
            cancel-button-text='Cancel'
            icon="el-icon-info"
            icon-color="red"
            :title="`Are you sure to void $${scope.row.amount}? ${scope.row.type === 'CHEQUE' ? 'This will trigger an email to the customer.' : ''}`"
            @confirm="handleVoid(scope.row)"
          >
            <el-button
              slot="reference"
              size="mini"
              type="warning"
              :disabled="scope.row.voided"
            >Void</el-button>
          </el-popconfirm>
          <el-popconfirm
            v-if="['ACH', 'CREDIT_CARD'].includes(scope.row.type) && scope.row.success"
            confirm-button-text='Confirm'
            cancel-button-text='Cancel'
            icon="el-icon-info"
            icon-color="red"
            :title="`Are you sure to refund wallet amount $${scope.row.amount}${scope.row.creditCardFee ? ' + CC Fee $'+ Math.round(scope.row.creditCardFee * 100) / 100: ''}?`"
            @confirm="handleRefund(scope.row)"
          >
            <el-button
              slot="reference"
              size="mini"
              type="danger"
              :disabled="scope.row.refunded"
            >Refund</el-button>
           </el-popconfirm>
        </template>
      </el-table-column>
      <el-table-column label="Sync" fixed="right">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.type === 'ACH' && scope.row.events[scope.row.events.length - 1].status === 'pending'"
            type="warning" size="mini"
            v-loading="loading"
            @click="handleSync(scope.row)"
          >SYNC</el-button>
        </template>
      </el-table-column>
      <el-table-column
        label="Sandbox"
        v-if="$root.state.facilityData && $root.state.facilityData.sandbox"
        :width="200"
      >
       <template
        v-if="scope.row.type === 'ACH' && scope.row.events[scope.row.events.length - 1].status.toUpperCase() === 'PENDING'"
        slot-scope="scope"
        >
        <el-button
          type="primary"
          size="mini"
          @click="() => handleAchPendingTransaction(scope.row)"
          >
            Settle
        </el-button>
       </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :title="selectedTransaction ? `Transaction ${selectedTransaction.id}` : 'Transaction Details'"
      :visible.sync="transactionDetailsDialog"
      destroy-on-close
      width="85%"
      @close="closeTransactionDetails"
    >
      <div v-loading="transactionDetailsLoading">
        <el-descriptions
          v-if="selectedTransaction"
          title="Transaction Details"
          border
          size="medium"
          direction="vertical"
        >
          <el-descriptions-item label="Id">
            <el-tag>{{ selectedTransaction.id }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="Customer">
            {{ getCustomerName(selectedTransaction) }}
          </el-descriptions-item>
          <el-descriptions-item label="Status">
            <el-tag
              v-if="!selectedTransaction.success"
              :type="getTransactionStatus(selectedTransaction).toUpperCase() === 'FAILED' ? 'danger' : 'warning' "
            >
              {{ getTransactionStatus(selectedTransaction).toUpperCase() }}
            </el-tag>
            <el-tag v-else type="success">
              {{ getTransactionStatus(selectedTransaction).toUpperCase() }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="Type">
            {{ selectedTransaction.type }}
          </el-descriptions-item>
          <el-descriptions-item label="Created At">
            {{ selectedTransaction.createdAt | formatDate }}
          </el-descriptions-item>
          <el-descriptions-item label="Wallet Amount">
            {{ selectedTransaction.amount | currencySign($root.state.facilityData) }}
          </el-descriptions-item>
          <el-descriptions-item label="Total Amount">
            {{ getTransactionTotal(selectedTransaction) | currencySign($root.state.facilityData) }}
          </el-descriptions-item>
          <el-descriptions-item label="Initiated By">
            {{ selectedTransaction.createdBy || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="Description">
            {{ selectedTransaction.details || '-' }}
          </el-descriptions-item>
        </el-descriptions>

        <el-card v-if="selectedTransaction && selectedTransaction.refunded && selectedTransaction.refund" class="transaction-details-section" shadow="never">
          <el-descriptions title="Refund Details" border>
            <el-descriptions-item label="Status"> {{ selectedTransaction.refund.status }}</el-descriptions-item>
            <el-descriptions-item label="Refund by"> {{ selectedTransaction.refund.createdBy }}</el-descriptions-item>
            <el-descriptions-item label="Refund At"> {{ selectedTransaction.refund.createdAt | formatDate }}</el-descriptions-item>
            <el-descriptions-item
              v-for="(value, key, index) in getRefundTransactionDetails(selectedTransaction)"
              :key="index"
              :label="key"
            >
              <div v-if="typeof value === 'string' || typeof value === 'number'">
                {{ value }}
              </div>
            </el-descriptions-item>
          </el-descriptions>
        </el-card>

        <el-card class="transaction-details-section" shadow="never">
          <template slot="header">
            Wallet Transactions
          </template>
          <el-table
            :data="walletTransactions"
            :row-class-name="walletTransactionRowClassName"
          >
            <el-table-column label="Id" prop="id"></el-table-column>
            <el-table-column label="Status" :width="170">
              <template slot-scope="scope">
                <el-tag
                  v-if="scope.row.refunded"
                  type="danger"
                  effect="dark"
                >
                  REFUNDED - INVALID
                </el-tag>
                <el-tag
                  v-else-if="scope.row.voided"
                  type="warning"
                  effect="dark"
                >
                  VOIDED - INVALID
                </el-tag>
                <el-tag v-else type="success" effect="plain">
                  VALID
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              label="Amount In Use"
              prop="amount"
              :formatter="(row, column, cellValue ) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)"
            ></el-table-column>
            <el-table-column
              label="Created at"
              prop="createdAt"
              :formatter="(row, column, cellValue ) => $options.filters.formatDate(cellValue, this.$root.state.facilityData)"
            ></el-table-column>
            <el-table-column label="Details" prop="details"></el-table-column>
            <el-table-column label="Document">
              <template slot-scope="scope">
                <el-button
                  v-if="getDocumentUrl(scope.row)"
                  size="small"
                  type="primary"
                  icon="el-icon-view"
                  @click="() => openPreview(getDocumentUrl(scope.row))"
                ></el-button>
                <a
                  v-if="getDocumentUrl(scope.row)"
                  :href="getDocumentUrl(scope.row)"
                  download
                >
                  <el-button
                    size="small"
                    type="secondary"
                    icon="el-icon-download"
                  ></el-button>
                </a>
                <el-tag v-if="!getDocumentUrl(scope.row)" type="info">
                  No Document
                </el-tag>
              </template>
            </el-table-column>
          </el-table>
        </el-card>

        <el-card class="transaction-details-section" shadow="never">
          <template slot="header">
            Refund Transactions
          </template>
          <el-table :data="refundTransactions">
            <el-table-column label="Id" prop="ref.id"></el-table-column>
            <el-table-column
              label="Amount Refunded"
              prop="amount"
              :formatter="(row, column, cellValue ) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)"
            ></el-table-column>
            <el-table-column
              label="Created at"
              prop="createdAt"
              :formatter="(row, column, cellValue ) => $options.filters.formatDate(cellValue, this.$root.state.facilityData)"
            ></el-table-column>
            <el-table-column label="Created By" prop="createdBy"></el-table-column>
            <el-table-column label="Reason" prop="ref.reason"></el-table-column>
          </el-table>
        </el-card>
      </div>
    </el-dialog>
    <el-dialog
      title="Receipt"
      :visible.sync="dialogForPdf"
      append-to-body
      destroy-on-close
      @closed="closePreview"
    >
      <PreviewPdf
        v-if="dialogForPdf && selectedDocument"
        :key="receiptPreviewKey"
        :source="selectedDocument"
      />
    </el-dialog>

    <!-- <el-tabs v-model="activeTab">

      <el-tab-pane label="Cash" name="cash">
        <el-table v-loading="loading" :data="receipts">
          <el-table-column
            type="expand"
          >
            <template slot-scope="scope">
              <el-descriptions title="Disbursment Details">
                <el-descriptions-item
                  label="Disbursment Date"
                >
                  {{ new Date(scope.row.createdAt).toLocaleString() }}
                </el-descriptions-item>
                <el-descriptions-item
                  label="Details"
                >
                  {{ scope.row.details || '-' }}
                </el-descriptions-item>
              </el-descriptions>
            </template>
          </el-table-column>
          <el-table-column
            label="Transaction ID"
          >
            <template slot-scope="scope">
              <el-tag>
                {{scope.row.transaction}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="Amount"
          >
          <template slot-scope="scope">
            {{ Number(scope.row.amountPaid).toLocaleString('en', { style: 'currency', currency: 'USD' }) }}
          </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="Bank" name="bank">
        <el-table v-loading="loading" :data="transactions">
          <el-table-column
            type="expand"
          >
            <template slot-scope="scope">
              <el-descriptions title="Disbursment Details">
                <el-descriptions-item
                  label="Disbursment Date"
                >
                  {{ new Date(scope.row.createdAt).toLocaleString() }}
                </el-descriptions-item>
                <el-descriptions-item
                  label="Details"
                >
                  {{ scope.row.details || '-' }}
                </el-descriptions-item>
              </el-descriptions>
            </template>
          </el-table-column>
          <el-table-column
            label="Transaction ID"
          >
            <template slot-scope="scope">
              <el-tag>
                {{scope.row.transaction}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="Amount"
          >
          <template slot-scope="scope">
            {{ Number(scope.row.amountPaid).toLocaleString('en', { style: 'currency', currency: 'USD' }) }}
          </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="Cheque" name="cheque">
        <el-table v-loading="loading" :data="chequeTansactions">
          <el-table-column
            label="Cheque No"
          >
            <template slot-scope="scope">
              <el-tag>
                {{scope.row.chequeNo}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="Transaction ID"
          >
            <template slot-scope="scope">
              <el-tag>
                {{scope.row.transaction}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="Amount"
          >
          <template slot-scope="scope">
            {{ Number(scope.row.amountPaid).toLocaleString('en', { style: 'currency', currency: 'USD' }) }}
          </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="Wire" name="wire">
        <el-table v-loading="loading" :data="wireTansactions">
          <el-table-column
            label="Verified By"
          >
            <template slot-scope="scope">
              <el-tag>
                {{scope.row.verifiedBy}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="Transaction ID"
          >
            <template slot-scope="scope">
              <el-tag>
                {{scope.row.transaction}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="Amount"
          >
          <template slot-scope="scope">
            {{ Number(scope.row.amountPaid).toLocaleString('en', { style: 'currency', currency: 'USD' }) }}
          </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs> -->
  </el-card>
</template>

<script>
import axios from 'axios';
import PreviewPdf from './PreviewPdf';
import {
  PG_API_BASE,
  FACILITY_TRANSACTIONS_API_BASE,
  WALLET_TRANSACTIONS_API_BASE,
  REFUND_REQUEST_API_BASE,
} from '../env';

export default {
  name: 'CustomerTransactions',
  components: { PreviewPdf },
  props: {
    id: { type: String, required: true },
    facility: { type: String, required: true },
  },
  data() {
    return {
      loading: true,
      syncLoading: false,
      activeTab: 'cash',
      transactions: [],
      selectedTransaction: null,
      transactionDetailsDialog: false,
      transactionDetailsLoading: false,
      walletTransactions: [],
      refundTransactions: [],
      receipts: [],
      selectedDocument: null,
      dialogForPdf: false,
      receiptPreviewKey: 0,
    };
  },
  computed: {
    selectedTransactionEvents() {
      if (!this.selectedTransaction || !Array.isArray(this.selectedTransaction.events)) {
        return [];
      }

      return this.selectedTransaction.events;
    },
  },
  async mounted() {
    this.loading = true;
    await this.getCustomerFacilityAccountTransactions();
    this.loading = false;
  },
  watch: {
    async facility() {
      this.loading = true;
      await this.getCustomerFacilityAccountTransactions();
      this.loading = false;
    },
    async id() {
      try {
        this.loading = true;
        await this.getCustomerFacilityAccountTransactions();
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
  },
  methods: {
    async handleVoid(transaction) {
      this.loading = true;
      await this.voidTransaction(transaction);
      this.$emit('reload');
      this.loading = false;
    },
    async voidTransaction(transaction) {
      await axios.put(`${FACILITY_TRANSACTIONS_API_BASE}/v1/${this.facility}/transaction/void/cww/${transaction.id}`, {
        createdBy: this.$keycloak.tokenParsed.email,
      }, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });
      await this.getCustomerFacilityAccountTransactions();
    },
    async handleRefund(transaction) {
      if (this.loading) { return; }

      this.loading = true;

      if (!transaction.success) {
        this.loading = false;
        this.$notify.error({
          title: 'Error',
          message: 'Transaction can not be refunded.',
        });
        return;
      }

      if (transaction.events.length === 1) {
        this.loading = false;
        this.$notify.error({
          title: 'Error',
          message: 'Transaction can not be refunded, payment gateway response not found!',
        });
        return;
      }

      if (transaction.pgId || transaction.events[1]) {
        const transactionId = transaction.pgId
          ? transaction.pgId
          : (transaction.events[1].details.transaction
            ? transaction.events[1].details.transaction.id
            : transaction.events[1].details.result.transaction.id);

        const result = await this.handlePGRefund(transactionId);
        if (result.success || (result.transaction && result.transaction.refundedTransactionId)) {
          if (result.transaction.refundedTransactionId) {
            result.success = true;
          }

          await axios.put(`${FACILITY_TRANSACTIONS_API_BASE}/v1/${this.facility}/transaction/refund/pg/${transaction.id}`, {
            createdBy: this.$keycloak.tokenParsed.email,
            pgResponse: result,
          }, {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          });
          this.$emit('reload');
          await this.getCustomerFacilityAccountTransactions();
        }
      } else {
        this.$notify.error({
          title: 'Error',
          message: 'Transaction in Payment Gateway not found.',
        });
      }

      this.loading = false;
    },
    tableRowClassName({ row }) {
      if (row.voided) {
        return 'voided';
      }

      if (row.refunded) {
        return 'refunded';
      }

      return '';
    },
    walletTransactionRowClassName({ row }) {
      if (row.refunded || row.voided) {
        return 'wallet-transaction-invalid';
      }

      return '';
    },
    async handlePGRefund(transactionId) {
      if (transactionId) {
        const response = await axios.get(`${PG_API_BASE}/customer/transaction/${transactionId}`, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });

        const transactionResponse = response.data.result;
        if (transactionResponse.status === 'settled' || transactionResponse.status === 'completed' ) {
          const refundedResponse = await axios.get(`${PG_API_BASE}/customer/transaction/refund/${transactionId}`, {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          });
          const { result } = refundedResponse.data;
          if (!result.success) {
            this.$notify.error({
              title: 'Error',
              message: result.message,
            });
          } else {
            this.$notify.success({
              Title: 'Success',
              message: `Transaction: ${transactionId} has been refunded.`,
            });
          }
          return result;
        }
        this.loading = false;
        this.$notify.warning({
          title: 'Settlement Pending',
          message: 'Transaction is not yet settled, try refunding after settlement',
        });
        return null;
      }
      return null;
    },
    async handleSync(transaction) {
      this.syncLoading = true;
      const response = await axios.get(`${PG_API_BASE}/customer/transaction/${transaction.pgId}`, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });

      const pgTransaction = response.data && response.data.result ? response.data.result : null;

      if (pgTransaction && !(pgTransaction.status === 'settlement_pending' || pgTransaction.status === 'settling')) {
        this.loading = true;
        try {
          await axios.put(`${FACILITY_TRANSACTIONS_API_BASE}/v1/transaction/ach/${transaction.id}/pending`, {
            pgTransaction,
          }, {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          });
        } catch (err) {
          console.log(err);
        }

        this.$emit('reload');
        await this.getCustomerFacilityAccountTransactions();
        this.loading = false;
      }
      this.syncLoading = false;
    },
    async handleAchPendingTransaction(transaction) {
      try {
        this.loading = true;
        await axios.post(`${PG_API_BASE}/ach/webhook/mock`, {
          id: transaction.pgId, settle: true,
        }, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        this.loading = false;
        this.$notify.success({
          Title: 'Success',
          message: `Transaction: ${transaction.id} has been settled`,
        });
      } catch (err) {
        this.loading = false;
        console.log(err);
        this.$notify.error({
          title: 'Error',
          message: err.message,
        });
      }
      this.loading = true;
      await this.getCustomerFacilityAccountTransactions();
      this.loading = false;
    },
    async getCustomerTransactions() {
      try {
        const response = await axios.get(`${PG_API_BASE}/customer/transactions/${this.id}`, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        this.transactionIds = response.data.result;
      } catch (err) {
        this.$notify.error({
          title: 'Error',
          message: err.response.data.message,
        });
      }
    },
    async getTransactionByTransactionIds() {
      // eslint-disable-next-line no-restricted-syntax
      for (const id of this.transactionIds) {
        // eslint-disable-next-line no-await-in-loop
        const response = await axios.get(`${PG_API_BASE}/customer/transaction/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        this.transactions.push({ ...response.data.result, disableButton: false });
      }
    },
    async getCustomerFacilityAccountTransactions() {
      const response = await axios.get(`${FACILITY_TRANSACTIONS_API_BASE}/v1/${this.facility}/${this.id}`, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });

      this.transactions = response.data.result.transactions;
    },
    async openTransactionDetails(row) {
      this.selectedTransaction = row;
      this.transactionDetailsDialog = true;
      this.transactionDetailsLoading = true;
      this.walletTransactions = [];
      this.refundTransactions = [];
      this.receipts = [];

      try {
        const transactionResponse = await axios.get(`${FACILITY_TRANSACTIONS_API_BASE}/v1/transaction/${row.id}`, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });

        this.selectedTransaction = transactionResponse.data;
        await this.getReceiptsForSelectedTransaction();
        await Promise.all([
          this.getWalletTransactionsForSelectedTransaction(),
          this.getRefundTransactionsForSelectedTransaction(),
        ]);
      } catch (err) {
        console.log(err);
        this.$notify.error({
          title: 'Error',
          message: 'Unable to load transaction details.',
        });
      }

      this.transactionDetailsLoading = false;
    },
    closeTransactionDetails() {
      this.selectedTransaction = null;
      this.walletTransactions = [];
      this.refundTransactions = [];
      this.receipts = [];
      this.closePreview();
    },
    openPreview(url) {
      if (!url) {
        return;
      }

      this.dialogForPdf = false;
      this.selectedDocument = null;

      this.$nextTick(() => {
        this.selectedDocument = url;
        this.receiptPreviewKey += 1;
        this.dialogForPdf = true;
      });
    },
    closePreview() {
      this.dialogForPdf = false;
      this.selectedDocument = null;
    },
    getSelectedTransactionCustomerId() {
      /* eslint-disable no-underscore-dangle */
      if (
        this.selectedTransaction
        && this.selectedTransaction.customer
        && this.selectedTransaction.customer._id
      ) {
        return this.selectedTransaction.customer._id;
      }
      /* eslint-enable no-underscore-dangle */

      return this.id;
    },
    async getWalletTransactionsForSelectedTransaction() {
      /* eslint-disable no-underscore-dangle */
      if (!this.selectedTransaction || !this.selectedTransaction._id) {
        return;
      }

      const response = await axios.get(
        `${WALLET_TRANSACTIONS_API_BASE}/v1/${this.facility}/${this.getSelectedTransactionCustomerId()}/${this.selectedTransaction._id}`,
        {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        },
      );

      this.walletTransactions = response.data.map(
        item => this.addReceiptToWalletTransaction(item),
      );
      /* eslint-enable no-underscore-dangle */
    },
    async getRefundTransactionsForSelectedTransaction() {
      /* eslint-disable no-underscore-dangle */
      if (!this.selectedTransaction || !this.selectedTransaction._id) {
        return;
      }

      const response = await axios.get(
        `${REFUND_REQUEST_API_BASE}/v1/${this.facility}/${this.getSelectedTransactionCustomerId()}/${this.selectedTransaction._id}`,
        {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        },
      );

      this.refundTransactions = response.data.map(
        item => this.addReceiptToRefundTransaction(item),
      );
      /* eslint-enable no-underscore-dangle */
    },
    async getReceiptsForSelectedTransaction() {
      /* eslint-disable no-underscore-dangle */
      if (!this.selectedTransaction || !this.selectedTransaction._id) {
        return;
      }

      const response = await axios.get(
        `${WALLET_TRANSACTIONS_API_BASE}/v1/receipts/${this.facility}/${this.getSelectedTransactionCustomerId()}/${this.selectedTransaction._id}`,
        {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        },
      );

      this.receipts = response.data;
      /* eslint-enable no-underscore-dangle */
    },
    getCustomerName(transaction) {
      if (transaction.customer) {
        return transaction.customer.company || transaction.customer.fullName || '-';
      }

      return '-';
    },
    getTransactionStatus(transaction) {
      if (transaction.events && transaction.events.length) {
        return transaction.events[transaction.events.length - 1].status;
      }

      return '-';
    },
    getTransactionTotal(transaction) {
      if (transaction.type === 'CREDIT_CARD' && transaction.creditCardFee && transaction.success && transaction.enabledCreditCardFee) {
        return transaction.amount + transaction.creditCardFee;
      }

      if (transaction.type === 'CREDIT_CARD' && transaction.creditCardFee && !transaction.success) {
        return 0;
      }

      return transaction.amount;
    },
    getRefundTransactionDetails(transaction) {
      if (
        transaction.refund
        && transaction.refund.response
        && transaction.refund.response.transaction
      ) {
        return transaction.refund.response.transaction;
      }

      return {};
    },
    addReceiptToWalletTransaction(item) {
      /* eslint-disable no-underscore-dangle */
      const doc = this.receipts.find(
        receipt => this.getReceiptWalletTransactionId(receipt) === item._id,
      );
      /* eslint-enable no-underscore-dangle */

      if (!doc) {
        return item;
      }

      return { ...item, receipt: doc, url: doc.url };
    },
    addReceiptToRefundTransaction(item) {
      const doc = this.receipts.find(
        receipt => this.getReceiptWalletTransactionId(receipt) === item.parent,
      );

      if (!doc) {
        return item;
      }

      return { ...item, receipt: doc, url: doc.url };
    },
    getReceiptWalletTransactionId(receipt) {
      if (!receipt || !receipt.walletTransaction) {
        return null;
      }

      if (typeof receipt.walletTransaction === 'string') {
        return receipt.walletTransaction;
      }

      /* eslint-disable-next-line no-underscore-dangle */
      return receipt.walletTransaction._id || receipt.walletTransaction.id;
    },
    getDocumentUrl(row) {
      if (row.url) {
        return row.url;
      }

      if (row.receipt && row.receipt.url) {
        return row.receipt.url;
      }

      return null;
    },
  },
};
</script>

<style>
  .el-table .refunded {
    background: linear-gradient(10deg,#EF3B36, #ff9966, #ff5e62);
  }

  .el-table .voided {
    background: linear-gradient(75deg, #ff9966, #FFAF7B);
  }

  .transaction-details-section {
    margin-top: 16px;
  }

  .el-table .wallet-transaction-invalid {
    background: #fef0f0;
    color: #909399;
  }
</style>



// WEBPACK FOOTER //
// src/components/CustomerTransactions.vue